import React from "react";
import {
  Form,
  Input,
  Tooltip,
  Icon,
} from 'antd';

class RegistrationForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmDirty: false,
    }
  }

  handleConfirmBlur = e => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  compareToFirstPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && value !== form.getFieldValue('password')) {
      callback('Two passwords that you enter is inconsistent!');
    } else {
      callback();
    }
  };

  validateToNextPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    return (
      <Form {...formItemLayout} >
        <Form.Item
          label={
            <span>
              User Name&nbsp;
              <Tooltip title="This will be used to login">
                <Icon type="question-circle-o" />
              </Tooltip>
            </span>
          }
        >
          {getFieldDecorator('userName', {
            initialValue: '',
            rules: [
              {
                required: true,
                message: 'Please input your user name!',
                whitespace: true,
              },
              {
                min: 5,
                message: 'Username must be at least 5 characters long!',
              },
            ],
          })(<Input onChange={e => this.props.onChangeUserName(e.target.value)}/>)}
        </Form.Item>
        <Form.Item label="Password" hasFeedback>
          {getFieldDecorator('password', {
            initialValue: '',
            rules: [
              {
                required: true,
                message: 'Please input your password!',
              },
              {
                min: 8,
                message: 'Password must be at least 8 characters long!',
              },
              {
                validator: this.validateToNextPassword,
              },
            ],
          })(<Input.Password onChange={e => this.props.onChangePassword(e.target.value)}/>)}
        </Form.Item>
        <Form.Item label="Confirm Password" hasFeedback>
          {getFieldDecorator('confirm', {
            rules: [
              {
                required: true,
                message: 'Please confirm your password!',
              },
              {
                validator: this.compareToFirstPassword,
              },
            ],
          })(<Input.Password onBlur={this.handleConfirmBlur} onChange={e => this.props.onChangeConfirmPassword(e.target.value)}/>)}
        </Form.Item>
        <Form.Item
          label={
            <span>
              Display Name&nbsp;
              <Tooltip title="What do you want to display on screen">
                <Icon type="question-circle-o" />
              </Tooltip>
            </span>
          }
        >
          {getFieldDecorator('displayName', {
            rules: [{ whitespace: true }],
          })(<Input onChange={e => this.props.onChangeDisplayName(e.target.value)}/>)}
        </Form.Item>
      </Form>
    );
  }
}
  
export default Form.create({})(RegistrationForm);